import { useContext, useEffect, useState } from "react";
import "./Dashboard.css";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft";
import { SidebarContext } from "../../context/SidebarContext";
import { config } from "../../config";
import { FaCarAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { FaBoxOpen } from "react-icons/fa";
import { FcMoneyTransfer } from "react-icons/fc";
import { HiUserPlus } from "react-icons/hi2";
import { FaUserCheck } from "react-icons/fa";
import { FaUserTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

function Dashboard() {
  const { isSidebar } = useContext(SidebarContext);

  const [stats, setStats] = useState({
    totalDrivers: 0,
    totalUsers: 0,
    totalBookings: 0,
    totalEarnings: 0,
  });

  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}constants/dashboard-data`,
      );
      const result = await response.json();

      if (result.status) {
        setStats({
          ...result.data,
          totalDrivers: result.data.totalDrivers || 0,
          totalUsers: result.data.totalUsers || 0,
          totalBookings: result.data.totalBookings || 0,
          totalEarnings: result.data.totalEarnings || 0,
          pendingDrivers: result.data.pendingDrivers || 0,
          approvedDrivers: result.data.approvedDrivers || 0,
          rejectedDrivers: result.data.rejectedDrivers || 0,
        });
      }
    } catch (error) {
      console.error("Dashboard fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />

            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  {/* HEADER */}
                  <div className="dashboard-hero">
                    <div>
                      <span className="dashboard-eyebrow">
                        OPERATIONS OVERVIEW
                      </span>
                      <h2 className="flex fare-heading">
                        Welcome back to Click4Driver Admin Panel
                      </h2>
                      <p>
                        Live booking, payment, and driver signals for today.
                      </p>
                    </div>
                    <Link className="dashboard-hero-action" to="/bookings">
                      View bookings →
                    </Link>
                  </div>

                  {/* STATS */}
                  <div className="dashboard-stats">
                    {loading ? (
                      [1, 2, 3, 4].map((_, idx) => (
                        <div
                          className="stat-card skeleton"
                          key={idx}
                          style={{ height: "120px" }}
                        >
                          <div className="skeleton-title"></div>
                          <div className="skeleton-value"></div>
                        </div>
                      ))
                    ) : (
                      <>
                        <Link to="/bookings">
                          <StatCard
                            icon={<FaBoxOpen />}
                            title="Today's Bookings"
                            value={stats.todayBookings || 0}
                          />
                        </Link>
                        <Link to="/bookings/ongoing">
                          <StatCard
                            icon={<FaCarAlt />}
                            title="Active Trips"
                            value={stats.activeTrips || 0}
                          />
                        </Link>
                        <Link to="/bookings">
                          <StatCard
                            icon={<FcMoneyTransfer />}
                            title="Today's Revenue"
                            value={`₹ ${Number(stats.todayRevenue || 0).toFixed(2)}`}
                          />
                        </Link>
                        <Link to="/payouts">
                          <StatCard
                            icon={<FcMoneyTransfer />}
                            title="Payout Due"
                            value={`₹ ${Number(stats.payoutDue || 0).toFixed(2)}`}
                          />
                        </Link>
                      </>
                    )}
                  </div>
                  {!loading && (
                    <div className="attention-panel">
                      <div className="attention-heading">
                        <span className="dashboard-eyebrow">
                          LIVE OPERATIONS
                        </span>
                        {/* <h3>What needs attention</h3> */}
                        <p>Tap an item to open its work queue.</p>
                      </div>
                      <div className="attention-items">
                        <Link to="/bookings">
                          <b>{stats.unassignedBookings || 0}</b>
                          <span>Unassigned bookings</span>
                        </Link>
                        <Link to="/bookings">
                          <b>{stats.arrivedNotStarted || 0}</b>
                          <span>Arrived, not started</span>
                        </Link>
                        <Link to="/bookings">
                          <b>{stats.failedPayments || 0}</b>
                          <span>Failed payments</span>
                        </Link>
                        <Link to="/driver">
                          <b>{stats.pendingDriverDocuments || 0}</b>
                          <span>Documents pending</span>
                        </Link>
                        <Link to="/bookings/cancelled">
                          <b>
                            {Number(stats.cancellationRate || 0).toFixed(1)}%
                          </b>
                          <span>Cancellation rate</span>
                        </Link>
                        {/* <Link to="/queries"><b>{stats.openSupportTickets || 0}</b><span>Open support tickets</span></Link> */}
                      </div>
                      <div className="platform-totals">
                        <span>
                          <b>{stats.totalDrivers || 0}</b> Drivers
                        </span>
                        <span>
                          <b>{stats.totalUsers || 0}</b> Users
                        </span>
                        <span>
                          <b>{stats.totalBookings || 0}</b> All bookings
                        </span>
                        <span>
                          <b>₹ {Number(stats.totalEarnings || 0).toFixed(0)}</b>{" "}
                          Settled
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* STAT CARD COMPONENT */
const StatCard = ({ icon, title, value }) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <span className="stat-icon">{icon}</span>
        <h3>{title}</h3>
      </div>
      <p className="stat-value text-success">{value}</p>
    </div>
  );
};

export default Dashboard;
